import { handleErrors } from "../util/api-utils";

/**
 * Producer Override.
 * @param {function} successCallback The success callback function.
 * @param {function} errorCallback The error callback function.
 */
export function producerOverride(successCallback, errorCallback) {
    fetch("api/Licensing/ProducerOverride", {
        method: "get",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleErrors)
        .then(successCallback)
        .catch(errorCallback);
}
